import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretDown } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { useLiquidity } from "../../hooks/useLiquidity";
import { formatCompactNumber } from "../../utils/common";
import { PulseLoader } from "react-spinners";

const PoolTabelData = ({ t1, t2, pairs, totalLiq, poolAPR }: any) => {
  const navigate = useNavigate();
  const handleclick = () => {
    navigate(`/pools/${pairs.pair_name}`, {
      state: { pairs: pairs, token1: t1, token2: t2 },
    });
  };

  // const { getPoolTotalAmount, getPoolAPR } = useLiquidity();
  // const [totalLiq, setTotalLiq] = useState("");
  // const [poolAPR, setPoolAPR] = useState("");

  useEffect(() => {
    const getPools = async () => {
      // const { totalAmount } = await getPoolTotalAmount(pairs.pair_name);
      // setTotalLiq(totalAmount);
      // const poolAPR = await getPoolAPR(pairs.pair_name);
      // setPoolAPR(poolAPR.apr);
      // console.log("apr", Number(poolAPR));
    };
    getPools();
  }, [pairs]);

  const display = pairs.pair_type === "stable";

  return (
    <tr className="pool-rows" id={pairs.pair_name} onClick={handleclick} >
      <td>
        <div className="display_pool">
          <div>
            <img src={t1?.logo_URIs.png} alt="NOimg" height={50} width={50} />
            <img
              className="logo-overlap"
              src={t2?.logo_URIs.png}
              alt="NOimg"
              height={50}
              width={50}
            />
          </div>
          <div>
            {t1.display_denom}/{t2.display_denom}
          </div>
          {display ? (
            <div className="display-tag">
              <span>stable</span>
            </div>
          ) : (
            <></>
          )}
        </div>
      </td>
      {/* <td className="numeric-font">${totalLiq}</td> */}
      <td className="numeric-font">
        {(totalLiq || Number(totalLiq) === 0) ? (
          "$" + formatCompactNumber(totalLiq)
        ) : (
          <PulseLoader
            color="#1790FF"
            loading={true}
            // cssOverride={override}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        )}
      </td>
      <td className="numeric-font"></td>
      <td className="numeric-font">
        {(poolAPR || Number(poolAPR) ===0)? (
          Number(poolAPR) 
          ?
          poolAPR + "%"
          :
          "0.00 %"
        ) : (
          <PulseLoader
            color="#1790FF"
            loading={true}
            // cssOverride={override}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        )}
      </td>
    </tr>
  );
};

export default PoolTabelData;
